import { Literal, Union } from "runtypes";
import type { Static } from "runtypes";

export const QuestionAnswerStatus = Union(Literal("pinned"), Literal("unpinned"), Literal("removed"), Literal("pending_review"));
export type QuestionAnswerStatus = Static<typeof QuestionAnswerStatus>;
